/* GENERATED by scripts/gen-data.mjs — film scene "f-grounding" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_GROUNDING: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "frame",
      "id": "docs",
      "x": 14,
      "y": 16,
      "w": 186,
      "h": 268,
      "lKey": "films:f-grounding.items.docs.l"
    },
    {
      "k": "box",
      "id": "d1",
      "x": 26,
      "y": 48,
      "w": 162,
      "h": 40,
      "lKey": "films:f-grounding.items.d1.l"
    },
    {
      "k": "box",
      "id": "d2",
      "x": 26,
      "y": 94,
      "w": 162,
      "h": 40,
      "lKey": "films:f-grounding.items.d2.l"
    },
    {
      "k": "box",
      "id": "d3",
      "x": 26,
      "y": 140,
      "w": 162,
      "h": 40,
      "lKey": "films:f-grounding.items.d3.l"
    },
    {
      "k": "box",
      "id": "d4",
      "x": 26,
      "y": 186,
      "w": 162,
      "h": 40,
      "lKey": "films:f-grounding.items.d4.l"
    },
    {
      "k": "box",
      "id": "d5",
      "x": 26,
      "y": 232,
      "w": 162,
      "h": 40,
      "lKey": "films:f-grounding.items.d5.l"
    },
    {
      "k": "wire",
      "id": "wa",
      "from": "d3",
      "to": "sp",
      "dash": true
    },
    {
      "k": "box",
      "id": "sp",
      "x": 222,
      "y": 62,
      "w": 116,
      "h": 46,
      "lKey": "films:f-grounding.items.sp.l"
    },
    {
      "k": "wire",
      "id": "wb",
      "from": "sp",
      "to": "em"
    },
    {
      "k": "box",
      "id": "em",
      "x": 222,
      "y": 150,
      "w": 116,
      "h": 46,
      "lKey": "films:f-grounding.items.em.l"
    },
    {
      "k": "wire",
      "id": "wc",
      "from": "em",
      "to": "ix"
    },
    {
      "k": "box",
      "id": "ix",
      "x": 360,
      "y": 150,
      "w": 110,
      "h": 46,
      "lKey": "films:f-grounding.items.ix.l"
    },
    {
      "k": "wire",
      "id": "wd",
      "from": "ix",
      "to": "tk"
    },
    {
      "k": "box",
      "id": "tk",
      "x": 360,
      "y": 62,
      "w": 110,
      "h": 46,
      "lKey": "films:f-grounding.items.tk.l"
    },
    {
      "k": "chip",
      "id": "q",
      "x": 496,
      "y": 16,
      "w": 130,
      "h": 38,
      "lKey": "films:f-grounding.items.q.l"
    },
    {
      "k": "wire",
      "id": "we",
      "from": "q",
      "to": "tk",
      "dash": true
    },
    {
      "k": "wire",
      "id": "wf",
      "from": "tk",
      "to": "llm"
    },
    {
      "k": "box",
      "id": "llm",
      "x": 496,
      "y": 62,
      "w": 130,
      "h": 46,
      "lKey": "films:f-grounding.items.llm.l"
    },
    {
      "k": "wire",
      "id": "wg",
      "from": "llm",
      "to": "an"
    },
    {
      "k": "box",
      "id": "an",
      "x": 496,
      "y": 150,
      "w": 130,
      "h": 64,
      "lKey": "films:f-grounding.items.an.l"
    }
  ],
  "steps": [
    {
      "on": [
        "docs",
        "d1",
        "d2",
        "d3",
        "d4",
        "d5"
      ],
      "hot": [
        "docs"
      ],
      "capKey": "films:f-grounding.steps.0.cap"
    },
    {
      "on": [
        "docs",
        "d1",
        "d2",
        "d3",
        "d4",
        "d5",
        "sp",
        "wa"
      ],
      "hot": [
        "sp",
        "wa"
      ],
      "capKey": "films:f-grounding.steps.1.cap"
    },
    {
      "on": [
        "docs",
        "d1",
        "d2",
        "d3",
        "d4",
        "d5",
        "sp",
        "wa",
        "em",
        "ix",
        "wb",
        "wc"
      ],
      "hot": [
        "em",
        "ix",
        "wc"
      ],
      "capKey": "films:f-grounding.steps.2.cap"
    },
    {
      "on": [
        "docs",
        "d1",
        "d2",
        "d3",
        "d4",
        "d5",
        "sp",
        "wa",
        "em",
        "ix",
        "wb",
        "wc",
        "tk",
        "q",
        "we",
        "wd"
      ],
      "hot": [
        "tk",
        "wd",
        "we"
      ],
      "capKey": "films:f-grounding.steps.3.cap"
    },
    {
      "on": [
        "docs",
        "d1",
        "d2",
        "d3",
        "d4",
        "d5",
        "sp",
        "wa",
        "em",
        "ix",
        "wb",
        "wc",
        "tk",
        "q",
        "we",
        "wd",
        "llm",
        "an",
        "wf",
        "wg"
      ],
      "hot": [
        "llm",
        "an"
      ],
      "capKey": "films:f-grounding.steps.4.cap"
    }
  ]
};
